'use client'

import { tw } from '@/lib/utils'

import { NativeProductSelect } from './native-product-select'

export interface ModelFilterOption {
  value: string
  label: string
}

interface ModelFilterSelectProps {
  options: ModelFilterOption[]
  value: string
  onValueChange: (value: string) => void
  ariaLabel?: string
  /** Layout overrides, e.g. a full-width control inside a card. */
  className?: string
}

const ModelFilterSelect = ({ options, value, onValueChange, ariaLabel, className }: ModelFilterSelectProps) => {
  const selected = options.find((option) => option.value === value)
  return (
    <NativeProductSelect
      value={value}
      onValueChange={onValueChange}
      ariaLabel={ariaLabel ?? selected?.label ?? ''}
      options={options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
      className={tw(
        'relative flex w-full items-center justify-between rounded-full border border-black/10',
        'px-5 py-3 text-left lg:w-[250px]',
        className
      )}
    >
      <span className="text-navy block truncate text-[16px] font-light -tracking-[0.48px] lg:text-base lg:font-normal">
        {selected?.label}
      </span>
      <span>
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
          <path
            d="M1 1.5l5 5 5-5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </NativeProductSelect>
  )
}

export default ModelFilterSelect
